import { render } from "./PriceMould.vue?vue&type=template&id=50f08d2f"
import script from "./PriceMould.vue?vue&type=script&lang=js"
export * from "./PriceMould.vue?vue&type=script&lang=js"

import exportComponent from "/data/soft/jenkins/jobs/release-ms-front/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__